import { useState } from "react";
import { Card, CardBody, Col, ListGroup, ListGroupItem, Row } from "reactstrap";
import { ContactUs, Home, JsBehaviorTitle, Profile, Settings } from "../../../../Constants/Constants";
import { JsBehaviorSubTitle } from "../../../../Data/UiKits/Lists";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import JsBehaviorContent from "./JsBehaviorContent";

const JsBehavior = () => {
  const [activeList, setActiveList] = useState("1");
  return (
    <Col sm="12" xl="12">
      <Card>
        <CommonCardHeader title={JsBehaviorTitle} span={JsBehaviorSubTitle} />
        <CardBody className="behaviour-list">
          <Row>
            <Col sm="4">
              <ListGroup>
                <ListGroupItem action className={`bg-primary ${activeList === "1" && "active"}`} onClick={() => setActiveList("1")}>
                  {Home}
                </ListGroupItem>
                <ListGroupItem action className={`list-hover-primary ${activeList === "2" && "active"}`} onClick={() => setActiveList("2")}>
                  {Profile}
                </ListGroupItem>
                <ListGroupItem action className={`list-hover-primary ${activeList === "3" && "active"}`} onClick={() => setActiveList("3")}>
                  {ContactUs}
                </ListGroupItem>
                <ListGroupItem action className={`list-hover-primary ${activeList === "4" && "active"}`} onClick={() => setActiveList("4")}>
                  {Settings}
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col sm="8">
              <JsBehaviorContent tabId={activeList} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default JsBehavior;
